import { useEffect } from "react";
import CampaignEditor from "@form/components/campaign/Editor";
import PageHead from "@/components/common/PageHead";
import Link from "next/link";
import { pageView } from "@form/services/stat";
import { use100vh } from "react-div-100vh";
import { GetServerSidePropsContext } from "next";
import { getCampaign, processServerForm } from "@form/services/campaign";
import { formBlockMap } from "@form/components/form/modules";
import _ from "lodash";
import type { Form } from "@form/components/form/modules";
import store, { actions } from "@/stores";
import { backends } from "@/config/config";
import { useRouter } from "next/router";

import type { NextPage, GetStaticProps } from "next";

const Campaign: NextPage<{
  serverForm?: Form;
  error?: string;
}> = ({ serverForm, error }) => {
  const form = processServerForm(_.cloneDeep(serverForm));
  const blocks = formBlockMap(form);
  const tdk = {
    title: blocks?.title?.values?.title,
    description: blocks?.description?.values?.description,
  };
  const height = use100vh();
  const router = useRouter();
  useEffect(() => {
    pageView();
    if (process.env.NEXT_PUBLIC_APP_ENV !== "production") {
      const backend = backends.find((item) => {
        return item.value === store.getState().devtool.config.backend;
      });
      if (backend) {
        router.replace(`/forms/${router.query.id}?backend=${backend.label}`);
      }
    }
  }, []);

  return (
    <main
      style={{
        height: height ? `${height}px` : "100vh",
      }}
      className=" overflow-y-scroll overflow-x-hidden relative dark:bg-[#141414]"
    >
      <PageHead tdk={tdk}></PageHead>
      <div
        style={{
          height: height ? `${height}px` : "100vh",
        }}
        className="absolute bg-blue-linear w-full blur-[400px] opacity-[0.15]"
      ></div>
      <div className="max-w-[1013px] mx-auto relative">
        <div className="s-form:pt-[6vh]" id="editor">
          <CampaignEditor embed={false}></CampaignEditor>
        </div>
        <div className="w-full flex my-8 justify-center md:my-10 md:left-0">
          <Link href={"/"}>
            <a className="font-bold text-gray_95">Powered by KaratForm</a>
          </Link>
        </div>
      </div>
    </main>
  );
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { id, backend } = context.query;
  if (backend) {
    store.dispatch(
      actions.devtool.setConfig({
        ...store.getState().devtool.config,
        backend:
          backends.find((item) => {
            return item.label === backend;
          })?.value || "",
      })
    );
  }
  try {
    const form = await getCampaign(id as string, true);
    return {
      props: {
        serverForm: form,
      },
    };
  } catch (e: any) {
    return {
      props: {
        error: e.message,
      },
    };
  }
}

export default Campaign;
